// extracted by mini-css-extract-plugin
export default {"DashboardReps":"dashboardReps_DashboardReps__1RJyL","DashboardRepsTitle":"dashboardReps_DashboardRepsTitle__avpwM"};